type TDriveStatusIconProps = { projectId: string, fileId: string }

export default function DriveStatusIcon(_: TDriveStatusIconProps): JSX.Element|null {
  return null;
}
